/* eslint-disable jsx-a11y/aria-proptypes */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  toAbsoluteUrl,
  // sortCaret,
  // headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../../_metronic/_helpers";
import { useDispatch } from "react-redux";
import { setSelected } from "./taxOldSlice";
import { useHistory } from "react-router-dom";
import { sizePerPageList, formatCurrency } from "../../../utility";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";

export const TaxOldTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const showDetail = (column) => {
    dispatch(setSelected(column));
    history.push("/master/sap-tax-old/detail-data");
  };

  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList,
  };

  const columns = [
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, column) => (
        <div>
          <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">Detail</Tooltip>}
          >
            <a
              className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
              onClick={() => showDetail(column)}
            >
              <span className="svg-icon svg-icon-md svg-icon-primary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Write.svg"
                  )}
                />
              </span>
            </a>
          </OverlayTrigger>
        </div>
      ),
    },
    { text: "Client", dataField: "client" },
    { text: "Plant Code", dataField: "plantCode" },
    { text: "Billing Doc", dataField: "billingDoc" },
    { text: "Distr Channel", dataField: "distrChannel" },
    { text: "Tax Invoice Num", dataField: "taxInvoiceNumber" },
    { text: "Sales Office", dataField: "salesOffice" },
    { text: "VAT Regristration No", dataField: "vatRegNo" },
    { text: "Customer Name", dataField: "name" },
    { text: "Subtotal5", dataField: "subtotal5", formatter: formatCurrency },
    { text: "Amount", dataField: "amount", formatter: formatCurrency },
  ];

  return (
    <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        bootstrap4
        bordered={false}
        keyField="approvalDetailId"
        data={data}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        hover
      >
        <PleaseWaitMessage entities={loading ? null : data} />
        <NoRecordsFoundMessage entities={loading ? null : data} />
      </BootstrapTable>
    </>
  );
};
